import { apiPost } from '../axios.config'
import { API_ROUTES } from '../routes'
import { useMutationHook } from './mutationHook'

interface IPreviewAgreementResponse {
  agreementPreview: string
}

interface IPreviewAgreementParams {
  authorPhone?: string
  typeId: string
  substitutions?: {
    [key: string]: string
  }
  products?: string[]
}

async function fetchPreviewAgreement(path: string, body: IPreviewAgreementParams) {
  const { data } = await apiPost<IPreviewAgreementParams, IPreviewAgreementResponse>({ path, body })

  return data
}

export const usePreviewAgreement = (options?: {
  onSuccess?: (data: IPreviewAgreementResponse) => void
  onError?: (error: Error) => void
}) => {
  const path = API_ROUTES.AGREEMENT_PREVIEW
  const mutationFn = (url: string, body: IPreviewAgreementParams) => fetchPreviewAgreement(url, body)

  const mutationFunc = useMutationHook({
    path,
    mutationKey: [path],
    mutationFn,
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  })

  return mutationFunc
}
